/*
 * @Author: zhangguoliang
 * @Date: 2022-11-14 10:24:17
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2023-02-01 16:11:21
 */
import request from "@/utils/request";

export type Params = {
  pageNum: number;
  pageSize: number;
  Terminal: "pc" | "app";
  Port: number;
  sort?: number;
};

export type Response = {
  total: number;
  rows: Record<string, any>[];
  code: number;
  msg: string;
};

export function getCMS(params: Params): Promise<Response> {
  return request({
    url: "/dev-api/cms/cms/list",
    method: "GET",
    params,
  });
}

export type LiveParams = {
  roomId: string;
  videoId: string;
};

export function getLiveDetail(params: LiveParams): Promise<any> {
  return request({
    baseURL: process.env.VUE_APP_LIVE_URL,
    url: "/live/api/room/checkPlay",
    method: "GET",
    params,
  });
}

// http://172.16.13.174:8080/sys/region/list?level=2
export function getCityList(params: any): Promise<Response> {
  return request({
    baseURL: "http://travel.xiangnongjy.com/dev-api",
    url: "/sys/region/list?level=2",
    method: "GET",
    params,
    headers: {
      Authorization: 1,
    },
  });
}

export function register(data: any) {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: "/auth-resource/1/newregister",
    method: "POST",
    data,
  });
}

export function updatePassword(data: any) {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: "/passport-resources/1/passport/updatePassword",
    method: "POST",
    data,
  });
}

export function signIn(data: any) {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: "/auth-resource/oauth/token",
    method: "POST",
    data,
    headers: {
      Authorization: "Basic WElBTkdOT05HX1BPUlRBTDp4amxpZG9uZzEyMw==",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
}

export function getCaptcha(uuid: string) {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: `/auth-resource/1/captcha?uuid=${uuid}`,
    method: "get",
    responseType: "blob",
  });
}
// 1 登录 2注册 3修改密码
export function getSmsCode(mobile: string, type: number) {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: `/auth-resource/1/${type}/${mobile}/smsCode`,
    method: "get",
    headers: {
      TEMPLATE_CODE: "XIANGNONG_PORTAL",
    },
  });
}

export function checkMobile(mobile: string, type: number) {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: `/passport-resources/1/passport/${type}/${mobile}/checkMobile`,
    method: "get",
  });
}

export function changePass(data: any) {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: "/auth-resource/1/reset",
    method: "post",
    data,
  });
}

export function changeMobile(data: { phone: string; verifyCode: string }) {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: "/passport-resources/1/passport/updatePhone",
    method: "post",
    data,
  });
}

export function sendUpdatePhoneCode(data: { phone: string }) {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: "/passport-resources/1/passport/sendUpdatePhoneCode",
    method: "post",
    data,
  });
}

export function userInfo() {
  return request({
    baseURL: process.env.VUE_APP_YSF_URL + "/api",
    url: '/passport-resources/1/passport/userDetail',
    method: 'get',
  });
}